import React from 'react'
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom'
import { appPath } from './utils/appPath'
import UserProfilePage from './components/pages/UserProfile/Page'
import AdminSettingsPage from './components/pages/AdminSettings/Page'
import RateConfigurePage from './components/pages/RateConfigure/Page'
import EmailAccessPage from './components/pages/EmailAccess/Page'
import ClientAnalyticsPage from './components/pages/ClientAnalytics/Page'
import ClientManagementPage from './components/pages/ClientManagement/Page'
import CurrencyDashboardPage from './components/pages/CurrencyDashboard/Page'
import AccountOwnerPortfolioPage from './components/pages/AccountOwnerPortfolio/Page'
import TopClientsRevenuePage from './components/pages/TopClientsRevenue/Page'
import RevenueTrendsPage from './components/pages/RevenueTrends/Page'
import OutstandingCollectionsPage from './components/pages/OutstandingCollections/Page'
import OverdueInvoiceAgingPage from './components/pages/OverdueInvoiceAging/Page'
import RegionalClientPerformancePage from './components/pages/RegionalClientPerformance/Page'
import EntityPerformancePage from './components/pages/EntityPerformance/Page'
import RevenueSeasonalityPage from './components/pages/RevenueSeasonality/Page'
import TechnologyBillingOverviewPage from './components/pages/TechnologyBillingOverview/Page'
import { ProjectAnalysisPage } from './components/pages/ProjectAnalysis/Page'
import { ProjectDetailPage } from './components/pages/ProjectAnalysis/project-detail-page'
import EmployeeAnalysisPage, {
	EmployeeAnalysisRedirectFromTimesheet,
} from './components/pages/EmployeeAnalysis/Page'
import SubscriptionManagementPage from './components/pages/SubscriptionManagement/Page'

/** Preserves query string from legacy `/my-dashboard?category=...&useCase=…`. */
function MyDashboardRedirect() {
	const [params] = useSearchParams()
	const q = params.toString()
	const useCase = params.get('useCase')
	const base =
		useCase === 'UC-S10'
			? appPath('/entity-performance')
			: useCase === 'UC-O4'
				? appPath('/revenue-seasonality')
				: useCase === 'UC-T9'
					? appPath('/timesheet-insights')
					: appPath('/regional-client')
	return <Navigate to={q ? `${base}?${q}` : base} replace />
}

/**
 * v2 route tree. Render as child of `Route path="/v2/*"` (descendant `<Routes>`).
 */
export function V2Routes() {
	return (
		<Routes>
			<Route path="client-acquisition-retention" element={<ClientAnalyticsPage />} />
			<Route path="client-management" element={<ClientManagementPage />} />
			<Route path="currency-dashboard" element={<CurrencyDashboardPage />} />
			<Route path="account-owner-portfolio" element={<AccountOwnerPortfolioPage />} />
			<Route path="top-clients-revenue" element={<TopClientsRevenuePage />} />
			<Route path="revenue-trends" element={<RevenueTrendsPage />} />
			<Route path="outstanding-collections" element={<OutstandingCollectionsPage />} />
			<Route path="overdue-invoice-aging" element={<OverdueInvoiceAgingPage />} />
			<Route path="regional-client" element={<RegionalClientPerformancePage />} />
			<Route path="entity-performance" element={<EntityPerformancePage />} />
			<Route path="revenue-seasonality" element={<RevenueSeasonalityPage />} />
			<Route
				path="technology-billing-overview"
				element={<Navigate to={appPath('/timesheet-insights')} replace />}
			/>
			<Route
				path="timesheet-insights"
				element={<TechnologyBillingOverviewPage />}
			/>
			<Route path="project-analysis" element={<ProjectAnalysisPage />} />
			<Route path="project-analysis/:projectId" element={<ProjectDetailPage />} />
			<Route path="employee-analysis" element={<EmployeeAnalysisPage />} />
			<Route path="employee-analysis/:userId" element={<EmployeeAnalysisPage />} />
			<Route path="timesheet" element={<EmployeeAnalysisRedirectFromTimesheet />} />
			<Route
				path="timesheet-analysis"
				element={<Navigate to={appPath('/employee-analysis')} replace />}
			/>
			<Route path="my-dashboard" element={<MyDashboardRedirect />} />
			<Route path="profile" element={<UserProfilePage />} />
			<Route path="admin-settings" element={<AdminSettingsPage />} />
			<Route path="rate-config" element={<RateConfigurePage />} />
			<Route path="email-access" element={<EmailAccessPage />} />
				<Route path="subscription-management" element={<SubscriptionManagementPage />} />
			<Route
				index
				element={<Navigate to={appPath('/client-management')} replace />}
			/>
			<Route
				path="*"
				element={<Navigate to={appPath('/client-management')} replace />}
			/>
		</Routes>
	)
}
